<script setup>
  import { computed } from 'vue';
  import { useAuthStore } from '@stores/auth';

  const authStore = useAuthStore();

  const formatLastLogin = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };
  const isLoggedIn = computed(() => !!authStore.user);
  const formattedLastLogin = computed(() => formatLastLogin(authStore.user?.last_real_login_at));
</script>

<template>
  <div v-if="isLoggedIn" class="w-full mx-0 p-0">
   
      <div class="flex md:justify-end justify-center w-fit">
        <p class="text-sm text-gray-400">Último acesso: <b>{{ formattedLastLogin }}</b></p>
      </div>
    
  </div>
</template>
